import { Component, OnInit } from "@angular/core";
import { EmpresasService } from "../../../../shared/services/empresas.service";
import { VehiculoFrecuenteService } from "../../../../shared/services/vehiculo-frecuente.service";
import {
  ContratistaPesvPayload,
  ContratistaPesvService,
} from "../../../../shared/services/contratista-pesv.service";
import { Utils } from "../../../../shared/utils/Utils";
import { catchError, map } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
const Swal = require("sweetalert2");

@Component({
  selector: "app-contratista-pesv",
  templateUrl: "./contratista.component.html",
  styleUrls: ["./contratista.component.scss"],
})
export class ContratistaPesvComponent implements OnInit {
  cargando = false;
  guardandoTodo = false;
  proveedores: any[] = [];
  proveedoresFiltrados: any[] = [];
  filtro = "";
  pageSize = 10;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  opcionesTipoContratista = [
    { value: 1, label: "OCACIONAL" },
    { value: 2, label: "PERMANENTE" },
  ];

  opcionesVehiculoFrecuente: Array<{ value: number; label: string }> = [];
  registrosPorNit: Record<string, any> = {};

  constructor(
    private empresasService: EmpresasService,
    private vehiculoFrecuenteService: VehiculoFrecuenteService,
    private contratistaPesvService: ContratistaPesvService
  ) {}

  ngOnInit(): void {
    this.cargarOpcionesVehiculoFrecuente();
    this.cargarProveedores();
  }

  private valorVehiculoPorDefecto(): number {
    return this.opcionesVehiculoFrecuente.length ? this.opcionesVehiculoFrecuente[0].value : 1;
  }

  private inicializarCamposPesvEnProveedor(proveedor: any): any {
    const nit = String(proveedor?.nit || "");
    const registro = this.registrosPorNit[nit];
    const tipoVehiculoDefault = this.valorVehiculoPorDefecto();

    return {
      ...proveedor,
      id_contratista_pesv: Number(registro?.id || 0),
      tipo_contratista: Number(registro?.tipo_contratista ?? 1),
      servicios: String(registro?.servicios || ""),
      cantidad_conductores: Number(registro?.cantidad_conductores ?? 0),
      cantidad_vehiculos: Number(registro?.cantidad_vehiculos ?? 0),
      tipo_vehiculos: Number(registro?.tipo_vehiculos ?? tipoVehiculoDefault),
      tipo_vehiculos2: Number(registro?.tipo_vehiculos2 ?? tipoVehiculoDefault),
      guardando: false,
    };
  }

  private cargarOpcionesVehiculoFrecuente(): void {
    this.vehiculoFrecuenteService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.vehiculosFrecuentes)
          ? respuesta.vehiculosFrecuentes
          : [];

        const activos = lista.filter((item: any) => Number(item?.estado ?? 1) === 1);
        this.opcionesVehiculoFrecuente = activos.map((item: any) => ({
          value: Number(item.id),
          label: String(item.descripcion || "Sin descripcion"),
        }));

        if (!this.opcionesVehiculoFrecuente.length) {
          this.opcionesVehiculoFrecuente = [{ value: 1, label: "Sin datos" }];
        }

        this.proveedores = (this.proveedores || []).map((proveedor) =>
          this.inicializarCamposPesvEnProveedor(proveedor)
        );
        this.aplicarFiltro();
      },
      error: () => {
        this.opcionesVehiculoFrecuente = [
          { value: 1, label: "Moto" },
          { value: 2, label: "Carro" },
          { value: 3, label: "Camioneta" },
          { value: 4, label: "Bus" },
          { value: 5, label: "Ninguno" },
        ];
      },
    });
  }

  cargarProveedores(): void {
    this.cargando = true;

    forkJoin({
      proveedores: this.empresasService.getProveedores(),
      contratistasPesv: this.contratistaPesvService.getAll().pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ proveedores, contratistasPesv }) => {
        this.registrosPorNit = this.crearIndicePorNit(contratistasPesv);
        this.proveedores = this.normalizarRespuestaProveedores(proveedores).map((proveedor: any) =>
          this.inicializarCamposPesvEnProveedor(proveedor)
        );
        this.aplicarFiltro();
        this.cargando = false;
      },
      error: (error) => {
        console.error("Error al cargar proveedores para contratista PESV:", error);
        this.proveedores = [];
        this.proveedoresFiltrados = [];
        this.cargando = false;
      },
    });
  }

  private normalizarRespuestaContratistasPesv(respuesta: any): any[] {
    if (Array.isArray(respuesta)) {
      return respuesta;
    }

    if (Array.isArray(respuesta?.contratistas_pesv)) {
      return respuesta.contratistas_pesv;
    }

    if (Array.isArray(respuesta?.contratista_pesv)) {
      return respuesta.contratista_pesv;
    }

    if (Array.isArray(respuesta?.data)) {
      return respuesta.data;
    }

    return [];
  }

  private crearIndicePorNit(respuesta: any): Record<string, any> {
    const lista = this.normalizarRespuestaContratistasPesv(respuesta);
    const index: Record<string, any> = {};

    lista.forEach((item: any) => {
      const nit = String(item?.nit || "").trim();
      if (nit) {
        index[nit] = item;
      }
    });

    return index;
  }

  private normalizarRespuestaProveedores(respuesta: any): any[] {
    if (Array.isArray(respuesta)) {
      return respuesta;
    }

    if (Array.isArray(respuesta?.proveedores)) {
      return respuesta.proveedores;
    }

    if (Array.isArray(respuesta?.empresas)) {
      return respuesta.empresas;
    }

    return [];
  }

  aplicarFiltro(): void {
    const termino = (this.filtro || "").trim().toLowerCase();
    this.page = 1;

    const filtrados = !termino
      ? [...this.proveedores]
      : this.proveedores.filter((proveedor) => {
      const categorias = Array.isArray(proveedor?.categorias)
        ? proveedor.categorias
            .map((cat: any) => String(cat?.text || cat || "").toLowerCase())
            .join(" ")
        : "";

      return (
        String(proveedor?.nit || "").toLowerCase().includes(termino) ||
        String(proveedor?.nombre || "").toLowerCase().includes(termino) ||
        String(proveedor?.direccion || "").toLowerCase().includes(termino) ||
        String(proveedor?.servicios || "").toLowerCase().includes(termino) ||
        String(proveedor?.telefono || "").toLowerCase().includes(termino) ||
        String(proveedor?.celular || "").toLowerCase().includes(termino) ||
        String(proveedor?.email || "").toLowerCase().includes(termino) ||
        categorias.includes(termino)
      );
    });

    this.proveedoresFiltrados = filtrados;
    if (this.sortColumn) {
      this.sortData(this.sortColumn, true);
    }
  }

  sortData(column: string, preserveDirection = false): void {
    if (this.sortColumn === column && !preserveDirection) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else if (this.sortColumn !== column) {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    const listToSort = this.proveedoresFiltrados.length ? this.proveedoresFiltrados : this.proveedores;
    const direction = this.sortDirection === "asc" ? 1 : -1;

    listToSort.sort((a, b) => {
      let aVal: any = this.getNestedValue(a, column);
      let bVal: any = this.getNestedValue(b, column);

      if (typeof aVal === "string") {
        aVal = aVal.toLowerCase();
      }

      if (typeof bVal === "string") {
        bVal = bVal.toLowerCase();
      }

      if (aVal < bVal) {
        return -1 * direction;
      }

      if (aVal > bVal) {
        return 1 * direction;
      }

      return 0;
    });

    this.proveedoresFiltrados = [...listToSort];
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "";
  }

  actualizarNumero(proveedor: any, campo: string, valor: any): void {
    const numero = Number(valor);
    proveedor[campo] = Number.isNaN(numero) ? 0 : numero;
  }

  actualizarTexto(proveedor: any, campo: string, valor: any): void {
    proveedor[campo] = String(valor || "");
  }

  actualizarSelect(proveedor: any, campo: string, valor: any): void {
    proveedor[campo] = Number(valor);
  }

  guardarFilaContratista(proveedor: any): void {
    const nit = Number(proveedor?.nit || 0);
    if (!nit) {
      Swal.fire("Error", "NIT invalido", "error");
      return;
    }

    proveedor.guardando = true;

    const fechaActual = new Date().toISOString();
    const payload = this.construirPayloadContratista(proveedor, fechaActual);

    const id = Number(proveedor?.id_contratista_pesv || 0);
    const request$ = id
      ? this.contratistaPesvService.update(id, {
          ...payload,
          fecha_modificacion: fechaActual,
        })
      : this.contratistaPesvService.create(payload);

    request$.subscribe({
      next: (resp: any) => {
        proveedor.guardando = false;
        if (!id) {
          const idCreado = Number(resp?.id || resp?.contratista_pesv?.id || 0);
          if (idCreado) {
            proveedor.id_contratista_pesv = idCreado;
          }
        }
        Swal.fire("Exito", id ? "Registro actualizado." : "Registro guardado.", "success");
      },
      error: (error: any) => {
        proveedor.guardando = false;
        Swal.fire("Error", error?.error?.message || "Error al guardar", "error");
      },
    });
  }

  guardarTodo(): void {
    const filas = this.proveedoresFiltrados || [];
    if (!filas.length) {
      Swal.fire("Advertencia", "No hay filas para guardar.", "warning");
      return;
    }

    this.guardandoTodo = true;

    const fechaActual = new Date().toISOString();
    const requests = filas.map((proveedor) => {
      const nit = Number(proveedor?.nit || 0);
      if (!nit) {
        return of({ ok: false, proveedor });
      }

      proveedor.guardando = true;

      const payload = this.construirPayloadContratista(proveedor, fechaActual);
      const id = Number(proveedor?.id_contratista_pesv || 0);
      const request$ = id
        ? this.contratistaPesvService.update(id, {
            ...payload,
            fecha_modificacion: fechaActual,
          })
        : this.contratistaPesvService.create(payload);

      return request$.pipe(
        map((resp: any) => ({ ok: true, resp, proveedor })),
        catchError((error: any) => {
          proveedor.guardando = false;
          console.error("Error guardando contratista PESV:", error);
          return of({ ok: false, proveedor });
        })
      );
    });

    forkJoin(requests).subscribe((resultados: any[]) => {
      let guardados = 0;
      resultados.forEach((item: any, index: number) => {
        const proveedor = filas[index];
        if (proveedor?.guardando) {
          proveedor.guardando = false;
          const id = Number(proveedor?.id_contratista_pesv || 0);
          if (!id) {
            const idCreado = Number(item?.resp?.id || item?.resp?.contratista_pesv?.id || 0);
            if (idCreado) {
              proveedor.id_contratista_pesv = idCreado;
            }
          }

          if (!item?.ok) {
            guardados += 0;
          } else {
            guardados += 1;
          }
        }
      });

      this.guardandoTodo = false;
      const total = filas.length;
      if (guardados === total) {
        Swal.fire("Exito", `Se guardaron ${guardados} registros.`, "success");
      } else if (guardados > 0) {
        Swal.fire("Advertencia", `Se guardaron ${guardados} de ${total} registros.`, "warning");
      } else {
        Swal.fire("Error", "No se pudo guardar ningun registro.", "error");
      }
    });
  }

  private construirPayloadContratista(
    proveedor: any,
    fechaActual: string
  ): ContratistaPesvPayload {
    return {
      nombre: String(proveedor?.nombre || ""),
      nit: Number(proveedor?.nit || 0),
      tipo_contratista: Number(proveedor?.tipo_contratista || 1),
      servicios: String(proveedor?.servicios || ""),
      cantidad_conductores: Number(proveedor?.cantidad_conductores || 0),
      cantidad_vehiculos: Number(proveedor?.cantidad_vehiculos || 0),
      tipo_vehiculos: Number(proveedor?.tipo_vehiculos || this.valorVehiculoPorDefecto()),
      tipo_vehiculos2: Number(proveedor?.tipo_vehiculos2 || this.valorVehiculoPorDefecto()),
      estado: Number(proveedor?.estado ?? 1),
      fecha_creacion: fechaActual,
      fecha_modificacion: fechaActual,
    };
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

}
